// extracted by mini-css-extract-plugin
export var animationContainer = "_ed-0";
export var asteriskIcon = "_ed-8";
export var conversationLeftSection = "_ed-4";
export var conversationListItem = "_ed-3";
export var conversationMiddleSection = "_ed-5";
export var conversationRightSection = "_ed-6";
export var detailsContent = "_ed-1";
export var listContainer = "_ed-7";
export var modalContent = "_ed-2";